import type { PacketHeader } from './PacketHeader';

/**
 * Packet is a stack of packet headers, as seen on the wire:
 * the first header is usually ethernet header, then mpls or ip, and so on
 */
export type Packet = PacketHeader[];
